@if (!isAdminProject) {
  <app-header
    (menuOpenedEvent)="isMenuOpened = $event"
    (profileMenuOpenedEvent)="profileMenuOpened($event)"
  ></app-header>
  @if (isMobile) {
    <app-main-nav
      [opened]="isMenuOpened"
      [isProfileMenuOpened]="isProfileMenuOpened"
      (closeMenuEvent)="closeMenu()"
      (navigateEvent)="navigate($event)"
    >
      <div
        class="wrapper"
        [class.market]="isMarketPage"
        [class.overflow-hidden-container]="isLandingPage"
        [class.light-body]="isLightTheme"
      >
        <!--      <app-header (menuOpenedEvent)="isMenuOpened = $event"></app-header>-->
        <div class="main-content-wrapper">
          @if (isMobile) {
            <router-outlet></router-outlet>
            @if (!isProfilePage) {
              <div class="mobile-tabs">
                <div class="mobile-tabs-inner">
                  <div
                    class="mobile-tab main"
                    [class.active-tab]="router.url.includes('/landing') || router.url === '/'"
                    routerLink="/"
                  >
                    {{ 'MOBILE_TABS.MAIN' | translate }}
                  </div>
                  <div
                    class="mobile-tab markets"
                    [class.active-tab]="router.url.includes('/markets')"
                    routerLink="/markets"
                  >
                    {{ 'MARKETS.MARKETS' | translate }}
                  </div>
                  <div
                    class="mobile-tab trading"
                    [class.active-tab]="router.url.includes('trades')"
                    routerLink="/trades/USDT-BTC"
                  >
                    {{ 'MOBILE_TABS.TRADING' | translate }}
                  </div>
                  <div
                    class="mobile-tab wallets"
                    [class.active-tab]="router.url.includes('/wallets')"
                    routerLink="/wallets"
                  >
                    {{ 'MOBILE_TABS.WALLETS' | translate }}
                  </div>
                  <a
                    class="mobile-tab fiat-transactions"
                    [class.active-tab]="router.url.includes('fiat-transactions')"
                    routerLink="/fiat-transactions"
                  >
                    {{ 'MOBILE_TABS.FIAT' | translate }}
                  </a>
                  <!--                </div>-->
                  <!--                  <div-->
                  <!--                    class="mobile-tab main"-->
                  <!--                    [class.active-tab]="router.url.includes('/landing') || router.url === 'https://intebix.kz'"-->
                  <!--                    (click)="navigateProfile($event, 'landing')"-->
                  <!--                  >-->
                  <!--                    Main-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="mobile-tab markets"-->
                  <!--                    [class.active-tab]="router.url.includes('/markets')"-->
                  <!--                    (click)="navigateProfile($event, 'markets')"-->
                  <!--                  >-->
                  <!--                    Markets-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="mobile-tab trading"-->
                  <!--                    [class.active-tab]="router.url.includes('trades')"-->
                  <!--                    (click)="navigateProfile($event, 'trades/USDT-BTC')"-->
                  <!--                  >-->
                  <!--                    Trading-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="mobile-tab wallets"-->
                  <!--                    [class.active-tab]="router.url.includes('/wallets')"-->
                  <!--                    (click)="navigateProfile($event, 'wallets')"-->
                  <!--                  >-->
                  <!--                    Wallets-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="mobile-tab fiat-transactions"-->
                  <!--                    [class.active-tab]="router.url.includes('fiat-transactions')"-->
                  <!--                    (click)="navigateProfile($event, 'fiat-transactions')"-->
                  <!--                  >-->
                  <!--                    Fiat-->
                  <!--                  </div>-->
                </div>
              </div>
            }
          }
        </div>
        <app-footer class="footer" [class.market]="isMarketPage"></app-footer>
      </div>
    </app-main-nav>
  }
  @if (!isMobile) {
    <div class="wrapper" [class.market]="isMarketPage" [class.light-body]="isLightTheme">
      <div [class.overflow-hidden-container]="isLandingPage" class="main-content-wrapper">
        <router-outlet></router-outlet>
      </div>
      <app-footer class="footer" [class.market]="isMarketPage"></app-footer>
    </div>
  }
} @else {
  <div class="main-admin-wrapper">
    <router-outlet></router-outlet>
  </div>
}
